import { Button, Tag } from "antd";
import React from "react";
import { DateFormat } from "~/components/date/DateFormat.jsx";
import { TimeslotPicker } from "~/components/form/TimeslotPicker.jsx";
import { HelpLine } from "~/components/help/helpLine.jsx";
import { $t } from "~/i18n.js";

export default function StepReservering({
  voucherId,
  editMode,
  product,
  checkoutItem,
  setCheckoutItem,
  onNext,
  onPrev,
}) {
  if (!product) return null;

  // Derive the combined reserved_timeslot value for TimeslotPicker
  const timeslotValue =
    checkoutItem.reserved_timeslot ||
    (checkoutItem.date ? checkoutItem.date : null);

  const handleChange = (val) => {
    if (!val) {
      setCheckoutItem({
        ...checkoutItem,
        date: null,
        timeslot: null,
        reserved_timeslot: null,
      });
      return;
    }
    const sep = val.includes("T") ? "T" : " ";
    const parts = val.split(sep);
    const date = parts[0];
    const timeslot = parts[1] ? parts[1].slice(0, 5) : undefined;
    setCheckoutItem({
      ...checkoutItem,
      date,
      timeslot,
      reserved_timeslot: timeslot ? val : undefined,
    });
  };

  return (
    <>
      <div>
        {editMode && (
          <div
            className="row"
            style={{ alignItems: "flex-start", gap: 8, marginBottom: 12 }}
          >
            <p className="label title spacer">{$t("Wijzig huidige keuze")}</p>
            <Tag>
              {checkoutItem.reserved_timeslot ? (
                <DateFormat
                  date={checkoutItem.reserved_timeslot}
                  options={{
                    weekday: "short",
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  }}
                />
              ) : (
                $t("Geen tijdslot")
              )}
            </Tag>
          </div>
        )}

        <p className="label spacer">{$t("Kies een datum")}</p>

        <HelpLine className='small' style={{ marginTop: 8, marginBottom: 24 }}>
          {$t("Je kan ook op een later moment een datum kiezen.")}
        </HelpLine>

        <TimeslotPicker
          voucherId={voucherId}
          value={timeslotValue}
          onChange={handleChange}
          product={product}
          retrieveTimeslots={product.has_calendar}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 24,
        }}
      >
        <Button onClick={onPrev}>{$t("Terug")}</Button>
        <Button type="primary" onClick={onNext}>
          {$t("Volgende")}
        </Button>
      </div>
    </>
  );
}
